"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METASITE_APP_DEF_ID = exports.userSitesDefaultPolicy = exports.wixSitesDefaultPolicy = void 0;
exports.consentPolicyToHeaderObject = consentPolicyToHeaderObject;
function consentPolicyToHeaderObject(consentPolicy) {
    const mapping = {
        func: 'functional',
        anl: 'analytics',
        adv: 'advertising',
        dt3: 'dataToThirdParty',
        ess: 'essential',
    };
    const raw = {};
    for (const [cookieKey, policyField] of Object.entries(mapping)) {
        raw[cookieKey] = consentPolicy[policyField] ? 1 : 0;
    }
    return {
        'consent-policy': encodeURIComponent(JSON.stringify(raw)),
    };
}
exports.wixSitesDefaultPolicy = {
    essential: true,
    functional: true,
    analytics: true,
    advertising: false,
    dataToThirdParty: true,
};
exports.userSitesDefaultPolicy = {
    essential: true,
    functional: true,
    analytics: true,
    advertising: true,
    dataToThirdParty: true,
};
exports.METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
//# sourceMappingURL=utils.js.map